module.exports = __webpack_public_path__ + "img/logo-splash.7c2e1cf1.png";